export const matchFileName = (fileName, searchFileName) => {
  return fileName.toLowerCase() === searchFileName.toLowerCase();
};
